import { useEffect } from "react";

// Lightweight per-route SEO: sets document.title, meta description, and canonical.
export const Seo = ({ title, description, path = "" }) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }

    const origin = window.location.origin;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${origin}${path}`);
  }, [title, description, path]);

  return null;
};
